<dspx-card-set-base-form [fieldTypeReplacements]="fieldTypeReplacements"
                         [formServiceEndpoint]="formServiceEndpoint"
                         [templateId]="templateId"
                         [versionNo]="versionNo"
                         formName="Integrity Officer"
                         [entityId]="id"
                         (onFormLoad)="formLoaded($event)"
                         (onDialogSubmit)="dialogSubmitted($event)"
                         (onSave)="save($event)"
                         (onCancel)="cancel($event)">
</dspx-card-set-base-form>
